<div class="background-image">
  <tc-header>
    <tc-logo color="white" tagline="true"></tc-logo>
  </tc-header>

  <tc-forgot-form (submitted)="onSubmit($event)" [pending]="pending$ | async" [errorMessage]="error$ | async"
    [success]="success$ | async" [value]="value">
  </tc-forgot-form>
  <tc-title></tc-title>
</div>
